/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitializeApplicationResponse
 */
export interface InitializeApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof InitializeApplicationResponse
     */
    applicationId?: string;
}

/**
 * Check if a given object implements the InitializeApplicationResponse interface.
 */
export function instanceOfInitializeApplicationResponse(value: object): value is InitializeApplicationResponse {
    return true;
}

export function InitializeApplicationResponseFromJSON(json: any): InitializeApplicationResponse {
    return InitializeApplicationResponseFromJSONTyped(json, false);
}

export function InitializeApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitializeApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
    };
}

export function InitializeApplicationResponseToJSON(json: any): InitializeApplicationResponse {
    return InitializeApplicationResponseToJSONTyped(json, false);
}

export function InitializeApplicationResponseToJSONTyped(value?: InitializeApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
    };
}

